import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import { useHistory } from "react-router-dom";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import ActionTable from "../../../components/table/ActionTable";
import {
  Button,
  CircularProgress,
  ThemeProvider,
  createTheme,
} from "@mui/material";

let cpf = "";
export default function Cadastro(props) {
  const [lista, setLista] = useState([]);
  const [filhoSelecionado, setFilhoSelecionado] = useState(false);
  const [filho, setFilho] = useState({ id: 0 });
  const [paiId] = useState(Number(props.match.params.id));
  const [usuarioId, setUsuarioId] = useState(0);
  const { notification } = useContext(AppContext);
  const [dados, setDados] = useState({
    nome: "",
    cpf: "",
    email: "",
    senha: "",
  });
  const [dadosFilho, setDadosFilho] = useState({
    nome: "",
    chaveAcesso: "",
    escola: "",
    ciclo: "",
  });
  const [comboEscolas, setComboEscolas] = useState([]);
  const [ciclos, setCiclos] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (paiId) {
      listarFilhos();
      carregarPais();
      carregarComboEscolas();
      carregarCiclo();
    }
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregarCiclo = (params) => {
    api.get("ciclos/listar").then((res) => {
      setCiclos(res);
    });
  };

  const carregarPais = () => {
    setCarregando(true);
    api
      .get("pais/carregar", { id: paiId })
      .then((res) => {
        let dadosPai = {
          nome: res.usuarioNome,
          CPF: res.usuarioCPF,
          email: res.usuarioEmail,
          senha: res.senha,
        };
        setUsuarioId(res.usuarioId);
        setDados(dadosPai);
        setCarregando(false);
      })
      .catch((err) => {
        setCarregando(false);

        notification("error", "Não localizado");
      });
  };

  const history = props.history;

  const vincular = (form) => {
    cpf = form.cpf;

    api
      .put("pais/inserir", { vinculacao: true, CPF: form.cpf })
      .then((res) => {
        notification("success", "Usuário vinculado com sucesso!");
        history.push("/app/pai");
      })
      .catch((err) => {
        notification("error", "Não foi possível vincular");
      });
  };

  const cadastro = (params) => {
    let dadosParams = {
      nome: params.nome,
      CPF: params.CPF,
      email: params.email,
      senha: params.senha,
    };

    if (paiId) {
      api
        .post("usuarios/editar", {
          id: usuarioId,
          nome: params.nome,
          CPF: params.CPF,
          email: params.email,
        })
        .then((res) => {
          notification("success", "Dados cadastrais editado com sucesso!");
          carregarPais();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "CPF inválido");
            case 3:
              return notification("error", "Email inválido");
            case 4:
              return notification("error", "CPF já cadastrado");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      setDados(dadosParams);
      api
        .put("pais/inserir", dadosParams)
        .then((res) => {
          notification("success", "Pai cadastrado com sucesso!");
          history.push("/app/pai");
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "CPF inválido");
            case 3:
              return notification("error", "Email inválido");
            case 4:
              return notification("error", "Senha inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const editar = () => {};

  const fVinculo = {
    title:
      "Usuário já tem conta na Perto? Informe o CPF do usuário para criar o cadastro de pai",
    form: {
      cpf: {
        label: "CPF",
        type: "number",
        value: cpf,
      },
    },

    submit: {
      label: "salvar",
      action: vincular,
    },
  };

  const listarFilhos = () => {
    api
      .get("pais/listarFilhos", { paiId: paiId })
      .then((res) => {
        setLista(res);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar filhos");
      });
  };

  const abrirFilho = (registro) => {
    setFilho(registro);
    let dadosParams = dadosFilho;

    dadosParams.nome = registro.nome;
    dadosParams.chaveAcesso = registro.chaveAcesso;

    setDadosFilho(dadosParams);
    setFilhoSelecionado(true);
  };

  const tRegistros = {
    title: "Filhos/alunos",
    onLineClick: abrirFilho,
    newItemAction: () => setFilhoSelecionado(true),
    columns: [
      {
        name: "nome",
        label: "Nome",
      },
      {
        name: "escolaNomeFantasia",
        label: "Escola",
      },
      {
        name: "cicloNome",
        label: "Ciclo",
      },
    ],
    array: lista,
  };

  const camposfiltros = () => {
    const campos = {
      nome: {
        label: "Pai",
        type: "text",
        space: 8,
        value: dados.nome,
      },
    };

    campos.CPF = {
      label: "CPF",
      type: "number",
      space: 4,
      value: dados.CPF,
    };

    campos.email = {
      label: "Email",
      type: "text",
      space: 8,
      value: dados.email,
    };

    if (paiId === 0) {
      campos.senha = {
        label: "Senha",
        type: "text",
        value: dados.senha,
        space: 4,
      };
    }

    return campos;
  };

  const fFiltros = {
    title: paiId === 0 ? "Novo pai" : "Pai",
    form: camposfiltros(),
    submit: {
      label: "Salvar",
      action: cadastro,
    },
    history,
    close: true,
  };

  const salvarFilho = (params) => {
    let dadosParams = dadosFilho;
    let auxFilho = filho;
    auxFilho.escolaId = params.escolaId;
    auxFilho.cicloId = params.cicloId;

    dadosParams.nome = params.nome;
    dadosParams.chaveAcesso = params.chaveAcesso;
    dadosParams.escola = params.escola;
    dadosParams.ciclo = params.ciclo;

    setDadosFilho(dadosParams);

    if (filho.id) {
      api
        .post("pais/editarFilho", {
          id: filho.id,
          nome: params.nome,
          escolaId: params.escolaId,
          cicloId: params.ciclo,
          acessoLiberado: true,
        })
        .then((res) => {
          notification("success", "Filho editado com sucesso!");
          setFilhoSelecionado(false);
          listarFilhos();
          setDadosFilho({ nome: "", chaveAcesso: "", escola: "", ciclo: "" });
          setFilho({ id: 0 });
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification(
                "error",
                "Combinação inválida de ciclo e escola. Verifique os ciclos aquiridos pela escola."
              );
            case 3:
              return notification(
                "error",
                "Combinação inválida de ciclo e escola. Verifique os ciclos aquiridos pela escola."
              );
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("pais/inserirFilho", {
          paiId: paiId,
          nome: params.nome,
          chaveAcesso: params.chaveAcesso,
        })
        .then((res) => {
          notification("success", "Filho cadastrado com sucesso!");
          setFilhoSelecionado(false);
          listarFilhos();
          setDadosFilho({ nome: "", chaveAcesso: "", escola: "", ciclo: "" });
          setFilho({ id: 0 });
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Pai inválido");
            case 2:
              return notification("error", "Nome inválido");
            case 3:
              return notification("error", "Chave de acesso inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const camposfiltrosFilhos = () => {
    const campos = {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dadosFilho.nome,
      },
    };

    if (filho.id === 0) {
      campos.chaveAcesso = {
        label: "Chave de acesso",
        type: "text",
        space: 6,
        value: dadosFilho.chaveAcesso,
      };
    }

    if (filho.id > 0) {
      campos.escolaId = {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 3,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: filho.escolaId,
      };

      campos.cicloId = {
        label: "Ciclo",
        type: "select",
        emptyItem: true,
        space: 3,
        array: {
          data: ciclos,
          value: "id",
          desc: "nome",
        },
        value: filho.cicloId,
      };
    }

    return campos;
  };

  const fFilhos = {
    title: "Filho",
    form: camposfiltrosFilhos(),
    submit: {
      label: "Salvar",
      action: salvarFilho,
    },

    close: {
      label: "Fechar",
      action: () => {
        setFilhoSelecionado(false);
        setDadosFilho({ nome: "", chaveAcesso: "", escola: "", ciclo: "" });
        setFilho({ id: 0 });
      },
    },
  };

  return (
    <div>
      {!filhoSelecionado ? (
        <>
          {paiId === 0 && (
            <>
              <Form formData={fVinculo} />
            </>
          )}

          {carregando ? <CircularProgress /> : <Form formData={fFiltros} />}

          {paiId > 0 && (
            <>
              {carregando ? (
                <CircularProgress />
              ) : (
                <>
                  <ActionTable structure={tRegistros} />
                </>
              )}
            </>
          )}
        </>
      ) : (
        <Form formData={fFilhos} />
      )}
    </div>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#fa9702",
      color: "white",
    },
  },
});
